/* eslint-disable no-template-curly-in-string */
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import XHR from 'i18next-xhr-backend'
import moment from 'moment'
import { initReactI18next } from 'react-i18next'
import { setLocale } from 'yup'
import ENV_VARS from '@/config'
import 'moment/locale/zh-cn'

// Import local translation files for test environment
// import translationEN from '../../public/locales/en/translation.json'
// Import other languages similarly if needed

const isTestEnv = process.env.NODE_ENV === 'test'

const addYears = years => {
  const now = new Date()
  const future = new Date(now.getFullYear() + years, now.getMonth(), now.getDate())
  return future
}

i18n.use(LanguageDetector).use(initReactI18next)

if (!isTestEnv) {
  // Production and development environment configuration
  i18n.use(XHR).init({
    load: 'languageOnly',
    ns: ['translation', 'basic'],
    keySeparator: false,
    whitelist: ['en', 'fr', 'zh'],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      caches: ['cookie'],
      lookupCookie: 'NEXT_LOCALE',
      cookieOptions: { path: '/', sameSite: 'lax', expires: addYears(100) }
    },
    backend: {
      loadPath: ''.concat(ENV_VARS.APP_PATH, '/locales/{{lng}}/{{ns}}.json')
    }
  })
} else {
  const translation = await import('../../public/locales/en/translation.json')
  i18n.init({
    resources: {
      en: { translation }
      // Add other languages here if needed
    },
    fallbackLng: 'en',
    debug: false, // Set to true if you want to debug i18n issues
    interpolation: {
      escapeValue: false // Not needed for React
    },
    detection: {
      caches: ['cookie'],
      lookupCookie: 'NEXT_LOCALE',
      cookieOptions: { path: '/', sameSite: 'lax', expires: addYears(100) }
    }
  })
}

const LANGUAGES = {
  zh: 'zh-cn'
}

const FORMS = {
  en: {
    mixed: {
      default: 'Invalid',
      required: 'Required',
      notType: ({ type }) =>
        ({
          number: 'Please enter a valid number',
          date: 'Please enter a valid date'
        })[type]
    },
    number: {
      min: 'Should be at least ${min}',
      max: 'Should be at most ${max}',
      positive: 'Please enter a positive number',
      integer: 'Please enter an integer'
    },
    string: {
      email: 'Please enter a valid email',
      phone: 'Please enter a valid phone number',
      phoneEmail: 'Please enter a valid email or phone number',
      min: 'Should be at least ${min} characters',
      length: 'Should be ${length} characters'
    },
    array: {
      min: 'Please add at least one item'
    }
  },
  fr: {
    mixed: {
      default: 'Invalide',
      required: 'Obligatoire',
      notType: ({ type }) =>
        ({
          number: 'Entrez un nombre valide',
          date: 'Entrez une date valide'
        })[type]
    },
    number: {
      min: 'Doit être au moins ${min}',
      max: 'Doit être au plus ${max}',
      positive: 'Entrez un nombre positif',
      integer: 'Veuillez saisir un entier'
    },
    string: {
      email: 'Entrer un email valide',
      phone: 'Entrez un numéro de téléphone valide',
      phoneEmail: 'Entrez un e-mail ou un numéro de téléphone valide',
      min: 'Doit contenir au moins ${min} caractères',
      length: 'Doit contenir ${length} characters'
    },
    array: {
      min: 'Veuillez ajouter au moins un élément'
    }
  },
  zh: {
    mixed: {
      default: '无效',
      required: '必填',
      notType: ({ type }) =>
        ({
          number: '请输入合格数字',
          date: '请出入有效日期'
        })[type]
    },
    number: {
      min: '必须多余 ${min}',
      max: '必须少于 ${max}',
      positive: '请输入正数',
      integer: '请输入整数'
    },
    string: {
      email: '请输入有效电子邮件',
      phone: '请输入有效的手机号码',
      phoneEmail: '请输入有效邮箱或手机号码',
      min: '必须多余 ${min}',
      length: '应为 ${length} 个字符'
    },
    array: {
      min: '请添加至少一个项目'
    }
  }
}

setLocale(FORMS['en'])

i18n.on('languageChanged', function (lng) {
  const parsedLang = LANGUAGES[lng] || lng
  moment.locale(parsedLang)
  setLocale(FORMS[lng.substring(0, 2)])
})

export default i18n
/* eslint-enable no-template-curly-in-string */
